import { FunctionComponent } from 'react';

const Arrow: FunctionComponent<any> = ({ className, style, onClick }) => (
  <div className={className} style={{ ...style }} onClick={onClick}>
    &gt;
  </div>
);

export default Arrow;
